export default function advanceReturnDate(
  departureDate: Date,
  returnDate?: Date,
): Date {
  if (!returnDate) {
    const newReturnDate = new Date(departureDate);
    newReturnDate.setDate(departureDate.getDate() + 7);
    return newReturnDate;
  }
  return returnDate;
}
